import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ user, requiredPermission }) => {
    
    // 1. Check Login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // 2. Check Permission (If a specific module is required)
    if (requiredPermission) {
        // e.g. requiredPermission = "financeModule"
        // user.permissions.financeModule must be TRUE
        if (!user.permissions || !user.permissions[requiredPermission]) {
            return (
                <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
                    <div className="text-center">
                        <div style={{fontSize:'4rem'}}>🚫</div>
                        <h2 className="text-danger fw-bold">Access Denied</h2>
                        <p className="lead text-muted">You do not have permission to view this module.</p>
                        <a href="/" className="btn btn-primary mt-3">Go Home</a>
                    </div>
                </div>
            );
        }
    }

    // 3. Allowed! Render the Page.
    return <Outlet />;
};

export default ProtectedRoute;